import http from "../http-common";

const reserve = (trainId, seats, sessionId = null) => {
    const data = {
        train_id: trainId,
        seats: seats.map(seat => ({
            carriage_id: seat.carriage,
            seat_number: seat.seat
        }))
    };

    // Only include session_id if it's not null
    if (sessionId) {
        data.session_id = sessionId;
    }

    return http.post("/preliminary-reservations/reserve", data);
};

const release = (sessionId, trainId = null, seatIds = null) => {
    const data = { session_id: sessionId };
    if (trainId) data.train_id = trainId;
    if (seatIds) data.seat_ids = seatIds;

    return http.post("/preliminary-reservations/release", data);
};

const extend = (sessionId, trainId) => {
    return http.post("/preliminary-reservations/extend", {
        session_id: sessionId,
        train_id: trainId
    });
};

const PreliminaryReservationService = {
    reserve,
    release,
    extend
};

export default PreliminaryReservationService;